import type { ComponentType } from 'react';
import type { PanelScreen, ReportConfig } from './types/panelConfig';
import { SatisAnaliz } from './pages/SatisAnaliz';
import StokAnalizi from './pages/StokAnalizi';

export interface EkranProps {
  screen: PanelScreen;
  reports: ReportConfig[];
}

const DEFTER: Record<string, ComponentType<EkranProps>> = {
  'satis-analiz': SatisAnaliz,
  'stok-analiz': StokAnalizi,
};

/**
 * screen_key → sayfa bileşeni.
 * Bilinmeyen anahtar SatisAnaliz'e düşer: App.tsx bu defter açılmadan önce TÜM ekranları
 * koşulsuz SatisAnaliz'e bağlıyordu ve Template paneli 10 firmada ortak — davranış korunur.
 */
export function ekranBileseni(key: string): ComponentType<EkranProps> {
  return DEFTER[key] ?? SatisAnaliz;
}
